import * as Colors from '../../constants/Colors';
import { SvgIconProps } from '../IconProps';
import { BaseSvgIcon } from '../BaseSvgIcon';

export type QuoteMarkIconProps = SvgIconProps & {
    color?: keyof typeof Colors;
};

export const QuoteMarkIcon = ({ color = 'black', ...props }: QuoteMarkIconProps) => (
    <BaseSvgIcon viewBox="0 0 34 28" fill="none" {...props}>
        <path
            d="M0.48 18.76C0.48 11.44 4.68 4.6 10.2 0.759995L14.64 4.36C10.8 6.87999 7.44 11.68 6.96 15.52C7.08 15.52 7.92 15.28 8.52 15.28C11.88 15.28 14.4 17.92 14.4 21.4C14.4 25 11.52 27.88 7.92 27.88C3.96 27.88 0.48 24.64 0.48 18.76ZM19.68 18.76C19.68 11.44 23.88 4.6 29.4 0.759995L33.84 4.36C30 6.87999 26.64 11.68 26.16 15.52C26.4 15.52 27.24 15.28 27.72 15.28C31.08 15.28 33.6 17.92 33.6 21.4C33.6 25 30.72 27.88 27.12 27.88C23.16 27.88 19.68 24.64 19.68 18.76Z"
            fill={Colors[color]}
        />
    </BaseSvgIcon>
);

QuoteMarkIcon.defaultProps = {
    color: 'black' as keyof typeof Colors,
    height: '34px',
    width: '28px',
};
